<template>
	<v-snackbar
		v-model="showUpdate"
		bottom
		:timeout="-1"
	>
		Nova versão disponível!
		<v-spacer></v-spacer>
		<v-btn
			text
			class="mx-0"
			color="primary lighten-4"
			:loading="refreshing"
			:disabled="refreshing"
			@click="refreshApp"
		>
			Atualizar
		</v-btn>
		<v-btn
			icon
			color="grey"
			class="mx-0"
			@click="() => showUpdate = false"
		>
			<v-icon>mdi-close</v-icon>
		</v-btn>
	</v-snackbar>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const refreshing = ref(false)
const registration = ref<ServiceWorkerRegistration | null>(null)
const showUpdate = ref(false)

function showRefreshUI(e: Event) {
	registration.value = (e as CustomEvent<ServiceWorkerRegistration>).detail
	showUpdate.value = true
}

function refreshApp() {
	showUpdate.value = false
	if (!registration.value || !registration.value.waiting) return
	registration.value.waiting.postMessage('skipWaiting')
}

document.addEventListener(
	'swUpdated', showRefreshUI, { once: true },
)
navigator.serviceWorker.addEventListener(
	'controllerchange', () => {
		if (refreshing.value) return
		refreshing.value = true
		window.location.reload()
	},
)
</script>
